import { regExValidator } from '../../shared/validators/reg-ex.validator';

export const majorVersionRegExValidator = regExValidator(new RegExp('^[A-Z]{1,2}$'), 'Major Version must match A - ZZ');
export const majorVersionDefaultPlaceholer = 'e.g. A or BC';
